import Client from '@/client'

export default {
  list() {
    return Client.get(`ducspermits/`, { params: { query: `{id,uuid,name,application{name},dataset{name},user{id,name},status,version,updated_at}` } })
  },
  retrieve(id) {
    return Client.get(`ducspermits/${id}/`, { params: { query: `{id,uuid,name,application{id,slug,name},dataset{id,uuid,name},methods{id,slug,name,version},settings,user{id,username},status,result,version,created_at,updated_at}` } })
  },
  predict(id, api, payload) {
    return Client.post(`ducspermits/${id}/predict/${api}/`, payload)
  },
  patch(id, api, payload) {
    return Client.post(`ducspermits/${id}/patch/${api}/`, payload)
  },
  frame(id) {
    return Client.get(`ducspermits/${id}/frame/`)
  },
  production(id, filters) {
    return Client.get(`ducspermits/${id}/production/`, { params: filters })
  },
  typeCurves(id, filters) {
    if (filters !== undefined) {
      return Client.post(`ducspermits/${id}/type_curves/`, filters)
    }
    return Client.get(`ducspermits/${id}/type_curves/`)
  },
  uniques(id) {
    return Client.get(`ducspermits/${id}/uniques/`)
  },
  filters(id) {
    return Client.get(`ducspermits/${id}/filters/`)
  },
  getWell(id, api, filters) {
    if (!!filters) {
      return Client.get(`ducspermits/${id}/well/${api}/`, { params: filters })
    } else {
      return Client.get(`ducspermits/${id}/well/${api}/`)
    }
  }
}